import {DashboardItem} from "@flexinet/ui-components";
import {rbacActions} from "../../../config/rbac/actions.ts";
import {UsersWidget} from "../components/dashboard/UsersWidget.tsx";
import {SupportWidget} from "../components/dashboard/SupportWidget.tsx";
import {OrganizationsWidget} from "../components/dashboard/OrganizationsWidget.tsx";
import {HealthWidget} from "../components/dashboard/HealthWidget.tsx";
import {ApplicationsWidget} from "../components/dashboard/ApplicationsWidget.tsx";

export const structure = {
    columns: [{
        span: 4,
        items: [
            {
                title: 'Users',
                component: <UsersWidget/>,
                height: 250,
                rbac: rbacActions.ListUsers
            }, {
                title: 'Organizations',
                component: <OrganizationsWidget/>,
                height: 250,
                rbac: rbacActions.ListOrganizations
            }] as DashboardItem[]
    }, {
        span: 4,
        items: [
            {
                title: 'Applications',
                component: <ApplicationsWidget/>,
                height: 250,
                rbac: rbacActions.ListApplications
            }] as DashboardItem[]
    }, {
        span: 4,
        items: [
            {
                title: 'Platform Health',
                component: <HealthWidget/>,
                height: 450,
                rbac: rbacActions.ListOrganizations
            }, {
                title: 'Support Cases',
                component: <SupportWidget/>,
                height: 450,
                rbac: rbacActions.GetSupport
            }] as DashboardItem[]
    }]
}